/* ------------------------------------------------------------------
   Nova — schede prodotto e pagine collezione
   1. Vista rapida (+ aggiornamento prezzo al cambio variante)
   2. Selettore colonne tablet/mobile (1 / 2 / 4-solo-immagini) + conteggio
   2b. Selettore colonne desktop (3 / 4 / 5=10-solo-immagini)
   3. Drawer filtri: pannello laterale anche su mobile
------------------------------------------------------------------ */
(function () {
  'use strict';

  function forceSide(element, side) {
    if (!element || element.getAttribute('data-nl-openfrom') === '1') return;
    try {
      element.setAttribute('data-nl-openfrom', '1');
      Object.defineProperty(element, 'openFrom', { configurable: true, get: function () { return side; } });
    } catch (e) {}
  }

  function forceQuickViewPanel() {
    var drawers = document.querySelectorAll('x-drawer[data-nl-quick-view-drawer]');
    for (var i = 0; i < drawers.length; i++) forceSide(drawers[i], 'right');
  }

  function forceFiltersPanel() {
    if (window.innerWidth > 699) return;
    var drawers = document.querySelectorAll('facet-drawer, .facets-drawer');
    for (var i = 0; i < drawers.length; i++) forceSide(drawers[i], drawers[i].getAttribute('open-from') || 'left');
  }

  function closeDrawer(drawer) {
    if (typeof drawer.hide === 'function') drawer.hide();
    else drawer.removeAttribute('open');
  }

  /* 1. Vista rapida -------------------------------------------------- */
  function loadQuickView(drawer, productUrl) {
    var holder = drawer.querySelector('[data-nl-quick-view-content]');
    if (!holder || drawer.dataset.nlLoading === '1') return;

    drawer.dataset.nlLoading = '1';
    holder.innerHTML = '<p class="text-center text-subdued">…</p>';

    var url = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'view=quick-view';

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        holder.innerHTML = html;
        var scripts = holder.querySelectorAll('script');
        for (var i = 0; i < scripts.length; i++) {
          var fresh = document.createElement('script');
          fresh.textContent = scripts[i].textContent;
          document.body.appendChild(fresh);
          document.body.removeChild(fresh);
        }
        var form = holder.querySelector('form');
        if (form) {
          form.addEventListener('submit', function () {
            setTimeout(function () { closeDrawer(drawer); }, 700);
          });
        }
        /* variante iniziale (per capire quando cambia davvero) */
        try {
          var vjson = holder.querySelector('script[data-variant]');
          if (vjson) {
            var vobj = JSON.parse(vjson.textContent);
            if (vobj && vobj.id) holder.dataset.nlVariant = String(vobj.id);
          }
        } catch (e) {}
        drawer.dataset.nlLoaded = '1';
        drawer.dataset.url = productUrl;
        delete drawer.dataset.nlLoading;
      })
      .catch(function () {
        holder.innerHTML = '<p class="text-center">Contenuto non disponibile.</p>';
        delete drawer.dataset.nlLoading;
      });
  }

  /* 1b. Vista rapida: aggiorna il prezzo al cambio variante (es. Dimensione).
     Il variant-picker della vista rapida non ha update-url e mostra un prezzo
     "a partire da", quindi da solo non cambia. Sostituiamo il nodo .price-list
     con quello reso dalla scheda prodotto per la variante scelta. */
  function updateQuickViewPrice(content, base, variantId) {
    content.dataset.nlVariant = String(variantId);
    var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
    var token = String(Date.now()) + '-' + variantId;
    content.dataset.nlPriceToken = token;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (content.dataset.nlPriceToken !== token) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var np = doc.querySelector('.product-info .price-list') || doc.querySelector('.price-list');
        var cp = content.querySelector('.price-list');
        if (np && cp) cp.replaceWith(np);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-nl-qv-close]');
    if (closer) {
      var host = closer.closest('x-drawer[data-nl-quick-view-drawer]');
      if (host) { event.preventDefault(); closeDrawer(host); }
      return;
    }

    var swatch = event.target.closest('[data-nl-quick-view-content] a.color-swatch, [data-nl-quick-view-content] a.color-swatch__view-more');
    if (swatch) {
      var swatchDrawer = swatch.closest('x-drawer[data-nl-quick-view-drawer]');
      var href = swatch.getAttribute('href');
      if (swatchDrawer && href) {
        event.preventDefault();
        loadQuickView(swatchDrawer, href.split('?')[0]);
      }
      return;
    }

    var button = event.target.closest('[data-nl-quick-view]');
    if (!button) return;
    var drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (!drawer || drawer.dataset.nlLoaded === '1') return;
    loadQuickView(drawer, drawer.dataset.url);
  });

  /* Cambio variante nella vista rapida: aspetta che il variant-picker abbia
     davvero aggiornato selectedVariant (aggiorna con un piccolo ritardo),
     poi ricarica il prezzo. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.closest) return;
    var content = input.closest('[data-nl-quick-view-content]');
    if (!content) return;
    var vp = input.closest('variant-picker');
    if (!vp) return;
    var drawer = content.closest('x-drawer[data-nl-quick-view-drawer]');
    var base = ((drawer && drawer.dataset.url) || '').split('?')[0];
    if (!base) return;

    clearTimeout(content._nlQvTimer);
    var tries = 0;
    (function poll() {
      var v = vp.selectedVariant;
      var id = v && v.id ? String(v.id) : null;
      if (id && id !== (content.dataset.nlVariant || '')) {
        updateQuickViewPrice(content, base, id);
        return;
      }
      if (tries++ < 25) content._nlQvTimer = setTimeout(poll, 40);
    })();
  });

  /* --- Icone (20px, traccia 1px netta con non-scaling-stroke) ------- */
  function svgWrap(inner) {
    return '<svg width="20" height="20" viewBox="0 0 18 18" aria-hidden="true">' + inner + '</svg>';
  }
  function rect(x, y, w, h) {
    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h +
      '" fill="none" stroke="currentColor" stroke-width="1" vector-effect="non-scaling-stroke"/>';
  }

  function iconOneSquare() {
    return svgWrap(rect('1.5', '1.5', '15', '15'));
  }

  function iconFourSquares() {
    /* 2x2 quadratini */
    return svgWrap(
      rect('1.5', '1.5', '6.4', '6.4') +
      rect('10.1', '1.5', '6.4', '6.4') +
      rect('1.5', '10.1', '6.4', '6.4') +
      rect('10.1', '10.1', '6.4', '6.4')
    );
  }

  function iconNineSquares() {
    /* 3x3 quadratini */
    var size = 3.93, gap = 1.6, pos = [1.5, 1.5 + size + gap, 1.5 + 2 * (size + gap)], s = '';
    for (var r = 0; r < 3; r++) {
      for (var c = 0; c < 3; c++) {
        s += rect(pos[c].toFixed(2), pos[r].toFixed(2), size.toFixed(2), size.toFixed(2));
      }
    }
    return svgWrap(s);
  }

  /* 2. Selettore colonne (tablet/mobile): 1 / 2 / 4-solo-immagini --- */
  var KEY = 'nl-cols-mobile-v3';
  var MOBILE_VALUES = ['1', '2', '4'];

  function currentCols() {
    try {
      var saved = localStorage.getItem(KEY);
      if (MOBILE_VALUES.indexOf(saved) !== -1) return saved;
    } catch (e) {}
    return '2';
  }

  function applyCols(value) {
    document.documentElement.setAttribute('data-nl-cols', value);
    try { localStorage.setItem(KEY, value); } catch (e) {}
    var buttons = document.querySelectorAll('.nl-cols__btn');
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute('data-cols') === value;
      buttons[i].classList.toggle('is-active', active);
      buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function colsIcon(cols) {
    if (cols === '1') return iconOneSquare();
    if (cols === '2') return iconFourSquares();
    return iconNineSquares();
  }

  function colsLabel(cols) {
    if (cols === '1') return 'Una colonna';
    if (cols === '2') return 'Due colonne';
    return 'Quattro per riga, solo immagini';
  }

  function findCount() {
    var candidates = document.querySelectorAll('.collection__results .v-stack p, .collection__top-bar .collection__count');
    for (var i = 0; i < candidates.length; i++) {
      if (/^\s*[\d.,\s]+\s*\S*prodott\S*\s*$/i.test(candidates[i].textContent || '')) return candidates[i];
    }
    return null;
  }

  function buildCols() {
    var bar = document.querySelector('.collection__top-bar');
    if (!bar) return;

    var group = bar.querySelector('.nl-cols-group');
    if (!group) {
      group = document.createElement('div');
      group.className = 'nl-cols-group';

      var wrap = document.createElement('div');
      wrap.className = 'nl-cols';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Colonne griglia prodotti');

      MOBILE_VALUES.forEach(function (cols) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'nl-cols__btn';
        button.setAttribute('data-cols', cols);
        button.setAttribute('aria-label', colsLabel(cols));
        button.innerHTML = colsIcon(cols);
        button.addEventListener('click', function () { applyCols(cols); });
        wrap.appendChild(button);
      });

      group.appendChild(wrap);
      bar.appendChild(group);
    }

    var count = findCount();
    if (count && count.parentNode !== group) {
      count.classList.add('collection__count');
      count.classList.remove('text-center');
      group.insertBefore(count, group.firstChild);
    }

    applyCols(currentCols());
  }

  /* 2b. Selettore colonne (desktop): 3 / 4 / 5=10-solo-immagini ----- */
  var KEY_D = 'nl-cols-desktop';
  var DESKTOP_VALUES = ['3', '4', '5'];

  function currentColsDesktop() {
    try {
      var saved = localStorage.getItem(KEY_D);
      if (DESKTOP_VALUES.indexOf(saved) !== -1) return saved;
    } catch (e) {}
    return '4';
  }

  function applyColsDesktop(value) {
    document.documentElement.setAttribute('data-nl-cols-desktop', value);
    try { localStorage.setItem(KEY_D, value); } catch (e) {}
    var buttons = document.querySelectorAll('.nl-cols-desktop__btn');
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute('data-cols') === value;
      buttons[i].classList.toggle('is-active', active);
      buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function colsIconDesktop(cols) {
    if (cols === '3') return iconOneSquare();
    if (cols === '4') return iconFourSquares();
    return iconNineSquares();
  }

  function colsLabelDesktop(cols) {
    if (cols === '3') return '3 colonne';
    if (cols === '4') return '4 colonne';
    return 'Griglia immagini (10 per riga)';
  }

  function buildColsDesktop() {
    var bar = document.querySelector('.collection__top-bar');
    if (!bar) return;
    if (bar.querySelector('.nl-cols-desktop-group')) { applyColsDesktop(currentColsDesktop()); return; }

    var group = document.createElement('div');
    group.className = 'nl-cols-desktop-group';

    var wrap = document.createElement('div');
    wrap.className = 'nl-cols-desktop';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Colonne griglia prodotti (desktop)');

    DESKTOP_VALUES.forEach(function (cols) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'nl-cols-desktop__btn';
      button.setAttribute('data-cols', cols);
      button.setAttribute('aria-label', colsLabelDesktop(cols));
      button.innerHTML = colsIconDesktop(cols);
      button.addEventListener('click', function () { applyColsDesktop(cols); });
      wrap.appendChild(button);
    });

    group.appendChild(wrap);

    var summary = bar.querySelector('.facets-summary');
    if (summary) summary.appendChild(group);
    else bar.appendChild(group);

    applyColsDesktop(currentColsDesktop());
  }

  applyCols(currentCols());
  applyColsDesktop(currentColsDesktop());

  function boot() {
    forceQuickViewPanel();
    forceFiltersPanel();
    buildCols();
    buildColsDesktop();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('x-drawer').then(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  try {
    new MutationObserver(boot).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
